import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Mail, Phone } from "lucide-react";
export default function GetInTouchWithUs() {
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <Card className="mx-auto max-w-3xl border border-border shadow-soft">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl font-semibold text-foreground">
              Contáctanos
            </CardTitle>
            <CardDescription className="mt-3 text-base text-muted-foreground">
              ¿Tienes preguntas sobre nuestros cursos y servicios? En Genesis Inversores estamos aquí para ayudarte.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-center text-foreground/90">
              Nuestro equipo de expertos está listo para guiarte en tu camino hacia el dominio de la bolsa de valores estadounidense. No dudes en comunicarte con nosotros.
            </p>
            
            <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
              <div className="flex items-center gap-2 text-sm text-foreground/80">
                <Mail className="h-5 w-5 text-primary" />
                <span>contacto@zafiroinvestment.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground/80">
                <Phone className="h-5 w-5 text-primary" />
                <span>+1 (555) 123-4567</span>
              </div>
            </div>

            <div className="flex justify-center pt-4">
              <Button size="lg" asChild className="shadow-medium transition-all duration-[150ms] hover:-translate-y-0.5 hover:shadow-medium">
                <Link to="/ContactoPage">
                  Enviar mensaje
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}